<app-pre-loader *ngIf="loadingBar !== undefined && +(loadingBar.progress$|async) > 0"></app-pre-loader>
<!-- <app-pre-loader></app-pre-loader> -->
<app-topbar *ngIf="show"></app-topbar>
<!-- <app-sidepanels *ngIf="show"></app-sidepanels> -->
<ng-content></ng-content>
